import { useTheme } from "@emotion/react";
import { FormGroup, Grid, IconButton, Paper, Typography, Divider, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as CloseIcon } from "assets/close_icon.svg";
import { FieldArray, FormikProvider, useFormik } from "formik";
import CustomValidationText from "ui-components/CustomValidationText";
import * as Yup from "yup";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Menu } from "@mui/icons-material";
import Cookies from "js-cookie";
import { Primary, Secondary } from 'ui-components/Buttons';

const ReorderMetricsPopup = ({ handleClose, handleSubmit, configurationData, startupDetails, savedConfigurationData, isLoading = false }) => {
  // console.log(configurationData,"configurationData",savedConfigurationData,savedConfigurationData)
  const theme = useTheme();
  let [startup_id, setStartupID] = React.useState(Cookies.get("startup_id") || null);
  // const [configurations, setConfigurations] = useState(configurationData)
  // const [selectedCategory, setSelectedCategory] = useState(null)
  // const [showCustomTemplate, setShowCustomTemplate] = useState(false)

  const validationObj = {
    // currency_type: Yup.string().required("Currency is required").test("no-char-value-only-numbers", "Currency is required", (value) => {
    //   return value != "select_currency_type"
    // }),
    selected_template: Yup.array().of(Yup.object().shape(
      { keySlug: Yup.string().required("Key name is required"), unit: Yup.string().required("Unit is required") },
    )).required("Please select key").min(1, "Please select key"),
  }

  const validationSchema = Yup.object({ ...validationObj });
  let mandatoryFields = !isLoading ? configurationData?.flatMap(item => item?.metrics)?.filter(item => item?.mandatory === "true")?.map(item => item?.keySlug) : []

  const groupedData = !isLoading ? savedConfigurationData?.data?.reduce((acc, item) => {
    acc[item.categoryName] = acc[item.categoryName] || [];
    acc[item.categoryName].push(item);
    return acc;
  }, {}) : {};



  const savedDataFormatted = !isLoading ? Object.keys(groupedData)?.map((key, index) => {
    return ({
      _id: configurationData[index]["_id"],
      categoryName: key,
      metrics: groupedData[key]?.map((metric) => ({
        ...metric,
        defaultUnit: metric.unit,
        value: "",
        mandatory: mandatoryFields?.includes(metric?.keySlug) ? "true" : "false"
      })),
    })
  }) : []

  // console.log(savedDataFormatted, "savedDataFormatted")

  const initialCategories = configurationData?.map((template) => ({
    categoryName: template.categoryName,
    metrics: template.metrics.map((metric) => ({
      key: metric.key,
      keySlug: metric.keySlug,
      defaultUnit: metric.defaultUnit,
      value: "",
      mandatory: metric.mandatory
    })),
  })) || []

  // console.log(savedDataFormatted, initialCategories, "ffff")

  const combineArrays = (array1, array2) => {
    const combined = [...array1]; // Start with Array1

    array2.forEach((category2) => {
      // Find the matching category in Array1
      const category1 = combined.find(
        (category1) => category1.categoryName === category2.categoryName
      );

      if (category1) {
        // Merge unique metrics into the existing category
        const existingKeySlugs = new Set(
          category1.metrics.map((metric) => metric.keySlug)
        );

        const uniqueMetrics = category2.metrics.filter(
          (metric) => !existingKeySlugs.has(metric.keySlug)
        );

        category1.metrics.push(...uniqueMetrics);
      } else {
        // If the category doesn't exist, add it to the combined array
        combined.push(category2);
      }
    });

    return combined;
  };

  const formik = useFormik({
    initialValues: {
      // categories: configurationData.map((template) => ({
      //   categoryName: template.categoryName,
      //   metrics: template.metrics.map((metric) => ({
      //     key: metric.key,
      //     keySlug: metric.keySlug,
      //     defaultUnit: metric.defaultUnit,
      //     value: "",
      //     mandatory: metric.mandatory
      //   })),
      // })),
      categories:
        savedConfigurationData?.data?.length > 0 ? combineArrays(savedDataFormatted, initialCategories) :
          initialCategories,
      selected_template: savedConfigurationData?.data?.length > 0 ? savedConfigurationData?.data?.sort((a,b) => (a?.display_order - b?.display_order)) : [],
      currency_type: 'INR',
      custom_template_name: "",
      custom_template_type: "select_template_type"
    },

    validationSchema: validationSchema,
    enableReinitialize: false,
    validateOnChange: false,
    validateOnBlur: false,
    validateOnMount: false,
    onSubmit: (values, { setSubmitting }) => {
      // console.log(values.selected_template,"values.selected_template")
      let request = {
        startup_id: startup_id,
        configuredMetrics: values.selected_template?.map((item, index) => {

          return {
            categoryName: item?.categoryName,
            customField: item?.customField,
            display_order: index,
            key: item?.key,
            keySlug: item?.keySlug,
            unit: item?.unit,
            _id: item?._id
          }
        })
      }
      handleSubmit(request);
    },
  });

  // useEffect(() => {
  //   if (configurationData != null && savedConfigurationData?.data?.length > 0) {
  //     let selected = []
  //     configurationData.forEach(category => {
  //       category.metrics.forEach(metric => {
  //         savedConfigurationData?.data?.forEach(element => {
  //           if (element.customField == true) {
  //             if (selected.findIndex(item => { return item.keySlug == element.keySlug }) < 0) {
  //               if (category.categoryName == element.categoryName) {
  //                 category.metrics.push({
  //                   key: element.key,
  //                   keySlug: element.keySlug,
  //                   defaultUnit: element.unit,
  //                   value: "",
  //                   type: "custom",
  //                   category: element.categoryName
  //                 })
  //                 selected.push({ key: element.key, keySlug: element.keySlug, unit: element.unit, customField: true, category: element.categoryName })
  //               }
  //             }
  //           }
  //         });
  //         if (savedConfigurationData?.data?.findIndex(item => { return item.keySlug == metric.keySlug }) > -1) {
  //           selected.push({ key: metric.key, keySlug: metric.keySlug, unit: metric.defaultUnit == 'Currency' ? formik.values.currency_type : metric.defaultUnit, customField: false, category: category.categoryName })
  //         }
  //       });
  //     });
  //     // savedConfigurationData[0]?.configuredMetrics.forEach(element => {
  //     //   if (element.customField == true) {
  //     //     categories.${ catIndex }.metrics.push({
  //     //       key: element.key,
  //     //       keySlug: element.keySlug,
  //     //       defaultUnit: element.unit,
  //     //       value: "",
  //     //       type: "custom"
  //     //     })
  //     //     selected.push({ key: element.key, keySlug: element.keySlug, unit: element.unit, customField: true })
  //     //   }
  //     // });
  //     formik.setFieldValue("selected_template", [...new Set([...formik.values.selected_template, ...selected])])
  //   }
  // }, [configurationData, savedConfigurationData])

  // // console.log(savedConfigurationData,"savedConfigurationData")

  // useEffect(() => {
  //   // console.log(configurationData, 'configurationData', savedConfigurationData, "savedConfigurationData")
  //   if (configurationData != null && savedConfigurationData?.data.length == 0) {
  //     let selected = formik?.values?.selected_template
  //     configurationData.forEach(category => {
  //       // console.log(category,"category")
  //       category.metrics.forEach(metric => {
  //         if (metric.mandatory == "true") {
  //           if (selected.findIndex(item => item.keySlug == metric.keySlug) < 0) {
  //             // console.log("metric.key", metric)
  //             selected.push({ key: metric.key, keySlug: metric.keySlug, unit: metric.defaultUnit == 'Currency' ? formik.values.currency_type : metric.defaultUnit, customField: false, category: category.categoryName })
  //           }
  //         }
  //       });
  //     });
  //     formik.setFieldValue("selected_template", [...new Set([...formik.values.selected_template, ...selected])])
  //   }
  // }, [configurationData, formik?.values?.currency_type, savedConfigurationData])

  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  // useEffect(() => {
  //   const initializeFormValues = () => {
  //     let selected = [];

  //     if (savedConfigurationData?.data?.length > 0) {
  //       // Populate based on savedConfigurationData
  //       configurationData.forEach((category) => {
  //         category.metrics.forEach((metric) => {
  //           if (
  //             savedConfigurationData?.data?.some(
  //               (item) => item.keySlug === metric.keySlug
  //             )
  //           ) {
  //             selected.push({
  //               key: metric.key,
  //               keySlug: metric.keySlug,
  //               unit:
  //                 metric.defaultUnit === "Currency"
  //                   ? formik.values.currency_type
  //                   : metric.defaultUnit,
  //               customField: false,
  //               category: category.categoryName,
  //               display_order: metric?.display_order || selected?.length + 1
  //             });
  //           }
  //         });

  //         // Add custom fields from savedConfigurationData
  //         savedConfigurationData?.data?.forEach((element, index) => {
  //           if (element.categoryName === category.categoryName) {
  //             if (!category.metrics.some((item) => item.keySlug === element.keySlug)) {
  //               category.metrics.push({
  //                 key: element.key,
  //                 keySlug: element.keySlug,
  //                 defaultUnit: element.unit,
  //                 value: "",
  //                 type: "custom",
  //                 category: element.categoryName,
  //                 display_order: element?.display_order || index + 1,
  //               });
  //             }
  //             if (!selected.some((item) => item.keySlug === element.keySlug)) {
  //               selected.push({
  //                 key: element.key,
  //                 keySlug: element.keySlug,
  //                 unit: element.unit,
  //                 customField: true,
  //                 category: element.categoryName,
  //                 display_order: element?.display_order || index + 1,
  //               });
  //             }
  //           }
  //         });
  //       });
  //     } else {
  //       // Fallback to configurationData if no savedConfigurationData
  //       configurationData.forEach((category) => {
  //         category.metrics.forEach((metric) => {
  //           if (metric.mandatory === "true") {
  //             selected.push({
  //               key: metric.key,
  //               keySlug: metric.keySlug,
  //               unit:
  //                 metric.defaultUnit === "Currency"
  //                   ? formik.values.currency_type
  //                   : metric.defaultUnit,
  //               customField: false,
  //               category: category.categoryName,
  //               display_order: metric?.display_order || selected?.length + 1
  //             });
  //           }
  //         });
  //       });
  //     }

  //     // Deduplicate and set form values
  //     const uniqueSelectedTemplate = [
  //       ...new Map(
  //         [...formik.values.selected_template, ...selected].map((item) => [
  //           item.keySlug,
  //           item,
  //         ])
  //       ).values(),
  //     ];

  //     formik.setFieldValue("selected_template", uniqueSelectedTemplate);
  //   };

  //   initializeFormValues();
  // }, [configurationData, savedConfigurationData, formik.values.currency_type, isLoading]);

  // console.log(formik.values.selected_template,"ddd")


  const [dragIndex, setDragIndex] = useState(null)


  const onDragEnd = (result, values, setValues) => {
    const { source, destination } = result;

    // If no destination, do nothing
    if (!destination) return;

    // If dragged within the same category
    if (source.droppableId === destination.droppableId) {
      const reorderedItems = Array.from(values.selected_template);
      const [draggedItem] = reorderedItems.splice(source.index, 1);
      reorderedItems.splice(destination.index, 0, draggedItem);

      // Update display_order based on new position
      const updatedItems = reorderedItems.map((item, index) => ({
        ...item,
        display_order: destination.index, // Assuming display_order starts from 1
      }));

      // Set the updated values in Formik
      // console.log(reorderedItems,"reorderedItems")
      setValues({
        ...values,
        selected_template: updatedItems,
      });
    }
  };

  const onDragStart = (result) => {
    setIsDragging(true);
    setDragIndex(result.source.index);
  };

  useEffect(() => {
    const handleMouseMove = (event) => {
      if (isDragging) {
        setMousePosition({ x: event.clientX, y: event.clientY });
      }
    };

    // Add mousemove event listener
    document.addEventListener('mousemove', handleMouseMove);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isDragging]);



  return (
    <Paper
      sx={{
        background: theme.palette.customColors.whiteBG,
        borderRadius: "8px",
      }}
    >
      <IconButton sx={{ position: "absolute", top: 20, right: 20, padding: 0 }}>
        <CloseIcon width={40} height={40} onClick={handleClose} />
      </IconButton>
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <Grid display={"grid"} container padding={"1.5rem"}>
            <Grid item xs={12} mb={'1rem'}>
              <Typography
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: 700,
                  lineHeight: "28px",
                  color: theme.palette.customColors.g300,
                }}
              >
                Reorder Columns
              </Typography>
            </Grid>
            {/* <Grid display={'flex'} alignItems={'center'} gap={2} mb={'1rem'}>
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: 700,
                  lineHeight: "1rem",
                  color: theme.palette.customColors.g300,
                }}
              >
                Select Currency
              </Typography>
              <Grid
                item
              >
                <Select
                  size="small"
                  name={'currency_type'}
                  fullWidth
                  value={formik.values.currency_type}
                  onChange={(e) => {
                    formik.setFieldValue(
                      `currency_type`,
                      e.target.value
                    )
                  }
                  }
                  sx={{
                    background: theme.palette.customColors.whiteBG,
                    // paddingBlock: "6px",
                  }}
                >
                  <MenuItem value="select_currency_type" disabled>
                    Select currency type
                  </MenuItem>
                  {[{ label: "INR", value: "INR" }, { label: "USD", value: "USD" }]?.map(item => {
                    return <MenuItem value={item.value}>{item.label}</MenuItem>
                  })}
                </Select>
              </Grid>
              {formik.errors.currency_type && formik.touched.currency_type && (
                <CustomValidationText value={formik.errors.currency_type} />
              )}
            </Grid>
            <Divider /> */}
            <Divider />
            {/* <PerfectScrollbar containerRef={containerRef} style={{ height: "calc(100vh - 355px)" }}> */}
            {/* {console.log("categories", formik.values?.categories,formik.values?.selected_template)} */}
            <Grid marginBlock={"0.5rem"}>
              <DragDropContext
                onDragEnd={(result) => onDragEnd(result, formik.values, formik.setValues)}
                onDragStart={onDragStart}
                enableDefaultSensors

              >
                <Droppable droppableId="selected_template" direction="vertical" >
                  {(provided) => (
                    <>
                      <Box ref={provided.innerRef} {...provided.droppableProps} sx={{
                        display: 'grid', gap: "0.5rem", overflowY: 'auto', maxHeight: "calc(100vh - 355px)"
                        // Enable scrolling
                      }} id="drag-n-drop-scrollbar" >
                        <FieldArray name="selected_template" >
                          {(remove, push) =>
                            formik.values.selected_template?.sort((a, b) => a?.display_order - b?.display_order).map((selectedField, index) => {
                              let label = selectedField.key;
                              if (
                                selectedField.defaultUnit === "Currency" ||
                                selectedField.defaultUnit === "USD" ||
                                selectedField.defaultUnit === "INR"
                              ) {
                                if (formik.values.currency_type !== "select_currency_type") {
                                  label = label + " (" + formik.values.currency_type + ")";
                                }
                              } else if (selectedField.defaultUnit === "Months") {
                                label = label + " (Months)";
                              } else if (selectedField.defaultUnit === "Percentage") {
                                label = label + " (%)";
                              }

                              return (
                                <Draggable
                                  key={selectedField.keySlug} // Ensure key is unique
                                  draggableId={selectedField.keySlug}
                                  index={index}
                                >
                                  {(provided) => (
                                    <Grid
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      display="flex"
                                      alignItems="normal"
                                      sx={{
                                        ...provided.draggableProps.style,
                                        top: dragIndex === index ? `${mousePosition.y}px` : undefined,
                                        left: "auto !important",
                                        position: "static !important",
                                      }}
                                    >
                                      <FormGroup name={`selected_template.${index}.value`} sx={{
                                        flex: 1,
                                      }}>
                                        <Grid
                                          display="flex"
                                          border={
                                            savedConfigurationData?.data?.length > 0
                                              ? "1px solid #7c4dff"
                                              : "0px solid"
                                          }
                                          sx={{
                                            paddingBlock: "0.5rem",
                                            paddingInline: "0.5rem",
                                            borderRadius: "4px",
                                            bgcolor: "white"
                                          }}
                                        >
                                          <Typography marginRight={"0.5rem"}>
                                            {index + 1}.
                                          </Typography>

                                          {/* <FormControlLabel
                                            value={selectedField.keySlug}
                                            control={
                                              <Checkbox
                                                checked={
                                                  selectedField.mandatory === "true" ||
                                                    selectedField.type === "custom" ||
                                                    selectedField.customField === true
                                                    ? true
                                                    : formik.values?.selected_template.findIndex(
                                                      (item) => item.keySlug === selectedField.keySlug
                                                    ) > -1
                                                }
                                                onChange={(e) => {
                                                  if (
                                                    selectedField.mandatory === "true" ||
                                                    selectedField.type === "custom" ||
                                                    selectedField.customField === true
                                                  ) {
                                                    e.preventDefault();
                                                  } else {
                                                    let updatedTemplates = formik.values?.selected_template;
                                                    if (
                                                      updatedTemplates.findIndex(
                                                        (item) => item.keySlug === selectedField.keySlug
                                                      ) > -1
                                                    ) {
                                                      updatedTemplates = updatedTemplates.filter(
                                                        (template) => template.keySlug !== selectedField.keySlug
                                                      );
                                                    } else {
                                                      updatedTemplates.push({
                                                        key: selectedField.key,
                                                        keySlug: selectedField.keySlug,
                                                        unit:
                                                          selectedField.defaultUnit === "Currency"
                                                            ? formik.values.currency_type
                                                            : selectedField.defaultUnit,
                                                        customField: false,
                                                        category: selectedField.categoryName,
                                                      });
                                                    }
                                                    formik.setFieldValue(`selected_template`, updatedTemplates);
                                                  }
                                                }}
                                                style={{ color: "#7c4dff", paddingTop: "0rem" }}
                                                disableRipple
                                              />
                                            }
                                            label={label}
                                            sx={{ alignItems: "flex-start" }}
                                          /> */}
                                          <Typography variant="body1">
                                            {label}
                                          </Typography>
                                          {savedConfigurationData?.data?.length > 0 && (
                                            <Menu sx={{ marginLeft: "0.5rem", marginLeft: 'auto' }} />
                                          )}
                                          {/* {selectedField.type === "custom" || selectedField.customField === true ? (
                                            <Grid>
                                              <Secondary
                                                sx={{
                                                  padding: 0,
                                                  minWidth: 0,
                                                  background: "transparent",
                                                  border: "transparent",
                                                  marginLeft: "0.5rem",
                                                }}
                                                onClick={() => {
                                                  remove(index);
                                                  formik.setFieldValue(
                                                    "selected_template",
                                                    formik.values?.selected_template?.filter(
                                                      (item) => item?.keySlug !== selectedField?.keySlug
                                                    )
                                                  );
                                                }}
                                              >
                                                <DeleteIcon width={"1rem"} />
                                              </Secondary>
                                            </Grid>
                                          ) : null} */}
                                        </Grid>
                                      </FormGroup>
                                    </Grid>
                                  )}
                                </Draggable>
                              );
                            })}
                        </FieldArray>

                      </Box>
                      {provided.placeholder}
                    </>
                  )}
                </Droppable>
              </DragDropContext>
              {formik.errors.selected_template && formik.touched.selected_template && (
                <CustomValidationText value={formik.errors.selected_template} style={{ marginLeft: 0 }} />
              )}

            </Grid>
            <Grid>
              <Divider />
            </Grid>
            {/* </PerfectScrollbar> */}
            <Grid item xs={12} mt={'1.5rem'} padding={"0 1.5rem"} display={'flex'} justifyContent={'center'}>
              <Primary
                type="submit"
                sx={{ padding: "0.75rem 1.25rem", fontSize: "1rem" }}
              >
                Submit
              </Primary>
            </Grid>
          </Grid>
        </form>
      </FormikProvider>
    </Paper >
  );
};

export default ReorderMetricsPopup;